export const INDEX_ROUTE = '';
//export const INDEX_ROUTE = '/cart'

export const API_BASE = 'https://ostapi.reallysimplestore.com/'; // 'http://localhost:8888/';

// Stripe
export const stripe_publishable_key = "pk_live_1rOSbDhTKj8PzhwCHdikJI9Z"; // live
//export const stripe_publishable_key = "pk_test_yzFDuxP1GTgaD2VZchqvGDa6"; // test



// WEBPACK FOOTER //
// ./src/config.js